export default {
    init(class_name, container) {
        let element = document.getElementsByClassName(class_name)[0];
        this.split(element, container, class_name);

        // if(elements.length > 0) {
        //     for(let i = 0; i < elements.length; i++) {
        //     }
        // }
    },
    async split(element, container, class_name) {
        if(element) {
            let li = element.getElementsByTagName('li');
            if(li.length > 0) {
                let split_array = await this.chunkArray(li, 2);
                if(split_array.length > 0) {
                    // await this.empty_element(element)
                    for(let i = 1; i < split_array.length; i++) {
                        console.log('Cloning to ' + container);
                        // var clone = element.cloneNode(true);
                        // clone.classList.remove(class_name);
                        // clone.classList.add(class_name + "_copy");
                        // clone.id = "";
                        // element.after(clone);
                        var ul = document.createElement('ul');
                        ul.classList.add(class_name + "_copy");
                        $(container).append(ul)

                        await this.add_elements(split_array[i], ul);
                        // $(element).clone().appendTo(container);
                    }
                }

                var ul = document.createElement('ul');
                ul.classList.add(class_name + "_copy");
                await this.add_elements(split_array[0], element);
                console.log(split_array);
            }
        }
    },
    async chunkArray(arr, n) {
        arr = Array.from(arr);
        var chunkLength = Math.max(arr.length/n ,1);
        var chunks = [];
        for (var i = 0; i < n; i++) {
            if(chunkLength*(i+1)<=arr.length)chunks.push(arr.slice(chunkLength*i, chunkLength*(i+1)));
        }
        return chunks; 
    },
    
    async add_elements(elements, parent) {
        if(elements.length > 0) {
            for(let i = 0; i < elements.length; i++) {
                console.log("Adding: ", elements[i]);
                $(parent).append(elements[i]);
            }
        }
    },

    async empty_element(element) {
        $(element).html = "";
    }
}